/* eslint-disable @nx/enforce-module-boundaries */
import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { tap } from 'rxjs';
import { DriverService } from 'admin-drivers/src/app/api/services/driver.service';
import { PreloadImgComponent } from '@t-llevo/common-ui';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 't-llevo-driver-personal-detail-tab',
  standalone: true,
  imports: [DatePipe, NgTemplateOutlet, PreloadImgComponent],
  template: `
    <div class="row w-100 py-2">
      <table class="details-table col-12 col-lg-7 mb-2">
        @if(data$()){
        <tr>
          <td>Nombre:</td>
          <td>{{ data$()?.user?.firstname }}</td>
        </tr>
        <tr>
          <td>Apellidos:</td>
          <td>{{ data$()?.user?.lastname }}</td>
        </tr>
        <tr>
          <td>Fecha de nacimiento:</td>
          <td>{{ data$()?.birthday | date : 'dd/MM/yyyy' }}</td>
        </tr>
        <tr>
          <td>Carnet o pasaporte:</td>
          <td>{{ data$()?.ci }}</td>
        </tr>
        <tr>
          <td>Número telefónico:</td>
          <td>{{ data$()?.user?.phone }}</td>
        </tr>
        }
      </table>
      <ng-container #outlet [ngTemplateOutlet]="content"> </ng-container>
    </div>

    <ng-template #content>
      <commonui-preload-img
        #img
        class="col-9 col-lg-5"
        [urlImg]="photo!"
        [containerClass]="'shadow-sm'"
        imgClass="w-100 h-100"
        [containerHeight]="100"
        [containerWidth]="100"
        unit="%"
        [style.height]="img.onErrorCount > 1 ? '200px !important' : ''"
      ></commonui-preload-img>
    </ng-template>
  `,
})
export class DriverPersonalDetailTabComponent implements AfterViewInit {
  private srv = inject(DriverService);
  protected photo: string | null = null;

  data$ = toSignal(
    this.srv.item$.pipe(
      tap((data) => {
        if (data) this.photo = data.photo;
      })
    )
  );

  @ViewChild('outlet', { read: ViewContainerRef }) outletRef!: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef })
  contentRef!: TemplateRef<unknown>;

  ngAfterViewInit(): void {
    this.srv.item$.subscribe(() => this.rerender());
  }

  private rerender() {
    this.outletRef.clear();
    this.outletRef.createEmbeddedView(this.contentRef);
  }
}
